define('modules/common/controller/ModalCookie',[], function() {
	var Controller = function(
		$scope,
		$modalInstance,
		LocalStorage) {

		$scope.closeModal = function() {
			$modalInstance.close();
		};

		$scope.DisclaimerAccept = function() {
			LocalStorage.setItem("DisclaimerAccept1-1-5", true);
			$modalInstance.close();
		};

		$scope.isDisclaimerAccepted = LocalStorage.getItem('DisclaimerAccept1-1-5', false);

	};

	return [
		"$scope",
		"$modalInstance",
		"LocalStorage",
		Controller
	];
});
